var map = {
  "./CancerriskGeneDetection.png": "33909",
  "./Chinesemedicine.png": "1055",
  "./accompanying.png": "8715",
  "./advancedPayment.png": "69258",
  "./disabled_CancerriskGeneDetection.png": "98814",
  "./disabled_Chinesemedicine.png": "77796",
  "./disabled_accompanying.png": "3626",
  "./disabled_advancedPayment.png": "23057",
  "./disabled_greenChannel.png": "84791",
  "./disabled_hainanSpecialMedicine.png": "20303",
  "./disabled_homePostoperativeCare.png": "20192",
  "./disabled_hospitalService.png": "78218",
  "./disabled_mentalRelease.png": "29623",
  "./disabled_proton.png": "18957",
  "./disabled_registeredAssistance.png": "47601",
  "./disabled_secondDiagnosis.png": "3298",
  "./disabled_tumourSpecialMedicine.png": "41700",
  "./disabled_urgencyCheck.png": "24066",
  "./greenChannel.png": "3418",
  "./hainanSpecialMedicine.png": "31704",
  "./homePostoperativeCare.png": "88723",
  "./hospitalService.png": "36053",
  "./icon_gouyaozhidao.png": "82041",
  "./icon_hesuanjiance.png": "302",
  "./icon_kaiyao.png": "56430",
  "./icon_manbingzixun.png": "95270",
  "./icon_tijianjiedu.png": "28202",
  "./icon_xianxiajiuyi.png": "78700",
  "./icon_yimiaozixun.png": "86958",
  "./icon_zixun.png": "26146",
  "./mentalRelease.png": "13016",
  "./proton.png": "224",
  "./registeredAssistance.png": "88424",
  "./secondDiagnosis.png": "85909",
  "./tumourSpecialMedicine.png": "75027",
  "./urgencyCheck.png": "36483"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 2563;
